import { Box, styled } from "@mui/material";

const HeroHeader = styled(Box)`
	width: 100vw;
	background-color: #212F3C;
	background-size: cover;
	background-position: center;
	max-height: 400px;
	min-height: 64px;
	height: 5vh;
`;

export default HeroHeader;
